"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = filter;
const lang_1 = require("../lang");
const forEach_1 = __importDefault(require("./forEach"));
function filter(obj, cb) {
    if (!(0, lang_1.isObject)(obj)) {
        return {};
    }
    const filteredObject = {};
    (0, forEach_1.default)(obj, (value, key) => {
        if (cb(value, key)) {
            filteredObject[key] = value;
        }
    });
    return filteredObject;
}
